import * as React from 'react';

import * as styles from './UndergroundWalkTimeInputWrapper.css';

export const UndergroundWalkTimeInputWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
